//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AddEditGroupMembers from "@/components/Admin/RolesAndUsers/AddEditGroupMembers/add-edit-group-members.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import QAuModelPicker from "../Generics/ModelPicker/qAuModelPicker.vue";

function parseData(object) {
    const returnVal = [];
    object.map(param => {
        const fields = param.fields.map(field => ({
            label: param.name,
            sublabel: field.name,
            value: field.name
        }));
        returnVal.push(...fields);
    });
    return returnVal;
}

function parseDataList(object) {
    let returnVal = [];
    returnVal = object.map(param => ({
        label: param.name,
        value: param.name
    }));

    return returnVal;
}

function parseDataListFields(object) {
    let returnVal = [];
    returnVal = object.fields.map(param => ({
        label: param.name,
        value: param.name
    }));
    return returnVal;
}

export default {
    components: {
        QAuModelPicker,
        AQInput,
        AddEditGroupMembers,
        AQButton,
        AQListBtn
    },
    props: {
        customSearch: { type: String, default: "" }, // v-model of the reports filter search
        customDataModelPlv: { type: Boolean, default: false }, // used to remove DM basic filter search and DM title for reports filter
        mode: { type: String, default: "b" },
        treeConfig: { type: Object, default: () => {} },
        noSearch: { type: Boolean, default: false },
        hideSystemVariables: { type: Boolean, default: false },
        dataModelFilter: { type: Object },
        multiple: { type: Boolean, default: false },
        value: { type: Object },
        showDataModel: { type: Boolean, default: true },
        showVariables: { type: Boolean, default: true },
        showUsers: { type: Boolean, default: true },
        showFreeText: { type: Boolean, default: false },
        hideFreePhone: { type: Boolean, default: false },
        removeMargin: { type: Boolean, default: false },
        hideFreeTextEmail: Boolean,
        hideFreeTextPhone: Boolean,
        showDataText: { type: Boolean, default: false },
        showDynamicDataText: { type: Boolean, default: false },
        defaultTab: { type: String, default: "treeModel" },
        maxHeight: { type: String, default: "auto" },
        selectedFields: { type: Array, default: () => [] },
        typeRecipients: { type: String, default: "" },
        enableSelectedUsers: { type: Boolean, default: false },
        basePath: { type: String, default: "" },
        blackList: { type: Object, default: () => ({}) } //blackList for picker
    },
    data() {
        return {
            selectedTab: "treeModel",
            selection: [],
            localSelection: [],
            localCheckedValues: {},
            searchModel: "",
            modelLoaded: false,
            modelSearchStarted: false,

            searchVariables: "",
            variablesLoaded: false,
            variablesSearchStarted: false,

            searchUsers: "",
            usersLoaded: false,
            rolesLoaded: false,
            usersSearchStarted: false,

            freeTextData: [],
            dataText: [],

            modelDataList: [],
            listDataList: [],
            selectedUsersGroups: [],
            alreadySelectedUsers: [],
            initialUsers: [],
            initialGroups: [],
            hideListBtn: ["edit", "more", "copy", "download"]

        };
    },
    validations: {
        emailValue: {
            required
        }
    },
    computed: {
        ...mapGetters("diagrams", [
            "modelForProcessDefinition",
            "variables",
            "externalTask",
            "selectedPluginUuid",
            "selectedPluginCode",
            "selectedPluginConfigData"
        ]),
        ...mapGetters("admin", ["userList", "getGroupsListApp"]),
        treeSettings() {
            return {
                ...this.treeConfig,
                mode: this.mode,
                multiple: this.multiple,
                notifications: !this.hideSystemVariables,
                noSearch: this.noSearch,
                forceUpdate: true,
                customSearch: this.customSearch
            };
        },
        listData() {
            return this.modelForProcessDefinition({
                withProps: { isList: true }
            });
        },

        model() {
            return this.modelForProcessDefinition(this.dataModelFilter);
        },

        oneTabOnly() {
            let countBooleans = 0;
            if (this.showDataModel) {
                countBooleans++;
            }
            if (this.showUsers) {
                countBooleans++;
            }
            if (this.showFreeText) {
                countBooleans++;
            }
            if (this.showDataText || this.showDynamicDataText) {
                countBooleans++;
            }
            return countBooleans === 1;
        },

        modelList() {
            const vm = this;

            if (!this.searchModel) {
                return this.model;
            }
            const items = [];
            let currentObj = {};

            this.modelSearchStarted = true;

            if (this.model.length) {
                this.model.forEach(el => {
                    currentObj = {};
                    currentObj.fields = [];
                    el.fields.forEach(elx => {
                        if (elx && elx.name.toLowerCase().indexOf(this.searchModel.toLowerCase()) !== -1) {
                            !currentObj.hasOwnProperty("name") ? currentObj.name = el.name : "";
                            currentObj.fields.push(elx);
                            currentObj.opened = true;
                        }
                    });
                    if (currentObj.hasOwnProperty("name")) {
                        items.push(currentObj);
                    }
                });
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    vm.modelSearchStarted = false;
                }, 500);
            });

            return items;
        },
        variablesList() {
            const vm = this;

            if (!this.searchVariables) {
                let items = [];
                if (this.hideSystemVariables) {
                    items = this.variables.filter(cell => (["Activity", "Action", "ExternalTask"].indexOf(cell.name) == -1));
                }
                return items.length ? items : this.variables;
            }
            const items = []; let currentObj = {}; let
                itemsArray = this.variables;

            if (this.hideSystemVariables) {
                itemsArray = this.variables.filter(cell => (["Activity", "Action"].indexOf(cell.name) == -1));
            }
            this.variablesSearchStarted = true;

            itemsArray.forEach(el => {
                currentObj = {};
                currentObj.fields = [];
                el.fields.forEach(elx => {
                    if (elx && elx.name.toLowerCase().indexOf(this.searchVariables.toLowerCase()) !== -1) {
                        currentObj.name = el.name;
                        currentObj.fields.push(elx);
                        currentObj.opened = true;
                    }
                });
                if (currentObj.hasOwnProperty("name")) {
                    items.push(currentObj);
                }
            });

            this.$nextTick(() => {
                setTimeout(() => {
                    vm.variablesSearchStarted = false;
                }, 500);
            });
            return items;
        },
        combinedUserRoleList() {
            this.getGroupsListApp.map(role => {
                role.isRole = true;
            });

            const list = [...this.userList, ...this.getGroupsListApp];

            return list.sort((a, b) => {
                const nameA = (a.firstName || a.name || a.email || "").toUpperCase();
                const nameB = (b.firstName || b.name || b.email || "").toUpperCase();

                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        },
        usersList() {
            const vm = this;

            if (!this.searchUsers) {
                return this.combinedUserRoleList;
            }
            let items = [];

            this.usersSearchStarted = true;
            items = this.combinedUserRoleList.filter(el => {
                const item = [el.firstName, el.lastName, el.name, el.email, ""];
                const searchItem = this.searchUsers.toLowerCase();
                for (let i = 0; i < item.length; i++) {
                    if (item[i] && item[i].toLowerCase().includes(searchItem)) {
                        return true;
                    }
                }
            });

            this.$nextTick(() => {
                setTimeout(() => {
                    vm.usersSearchStarted = false;
                }, 500);
            });

            return items;
        }
    },
    watch: {
        typeRecipients: {
            handler(newValue) {
                if (newValue) {
                    setTimeout(() => {
                        this.$root.$emit("resetSelectedMembers", this.alreadySelectedUsers);
                    }, 0);
                }
            }
        },
        selectedUsersGroups: {
            handler(newValue) {
                if (newValue.length) {
                    this.localCheckedValues.role = [];
                    this.localCheckedValues.user = [];
                    for (let i = 0; i < newValue.length; i++) {
                        const element = newValue[i];
                        if (element.type === "GROUP") {
                            if (this.localCheckedValues.role.includes(element.code)) {
                                continue;
                            } else if (!this.localCheckedValues.role.includes(element.id)) {
                                this.localCheckedValues.role.push(element.id);
                            }
                        } else if (!this.localCheckedValues.user.includes(element.id)) {
                            this.localCheckedValues.user.push(element.id);
                        }
                    }
                    if (!this.enableSelectedUsers) {
                        this.localCheckedValues.role = this.setAllUsersGroups(this.localCheckedValues.role, this.initialGroups);
                        this.localCheckedValues.user = this.setAllUsersGroups(this.localCheckedValues.user, this.initialUsers);
                    }
                } else if (this.enableSelectedUsers) {
                    this.localCheckedValues.role = [];
                    this.localCheckedValues.user = [];
                } else {
                    this.localCheckedValues.role = this.initialGroups;
                    this.localCheckedValues.user = this.initialUsers;
                }
                this.$emit("input", this.localCheckedValues);
            }
        },
        localCheckedValues: {
            handler(newValue) {
                if (newValue && this.enableSelectedUsers) {
                    this.alreadySelectedUsers = [...newValue.user, ...newValue.role];
                    this.initialUsers = [...newValue.user];
                    this.initialGroups = [...newValue.role];
                }
            }
        },
        localSelection(values) {
            this.selection = [...values];
        },
        value: {
            handler(newVal) {
                const defaultValues = {
                    user: [], role: [], model: [], variable: [], freeText: [], dataTextList: []
                };

                this.localCheckedValues = newVal ? { ...defaultValues, ...JSON.parse(JSON.stringify(newVal)) } : defaultValues;
                this.searchModel = "";
                this.searchVariables = "";
                this.searchUsers = "";
                const conditionForDataText = this.showDataText || this.showDynamicDataText;
                this.selectedTab = (this.selectedTab === "variables" && !this.showVariables) || (this.selectedTab === "users" && !this.showUsers)
                                    || (this.selectedTab === "freeText" && !this.showFreeText) || (this.selectedTab === "dataText" && !conditionForDataText)
                    ? "treeModel" : this.selectedTab;

                this.localSelection = [...this.localCheckedValues.model, ...this.localCheckedValues.variable];
            },
            immediate: true,
            deep: true
        },
        defaultTab: {
            handler(v) {
                if (v === "variables" || v === "dataModel") {
                    this.selectedTab = "treeModel";
                } else {
                    this.selectedTab = v;
                }
            },
            immediate: true
        },
        showDataModel: {
            handler(v) {
                const vm = this;

                if (v) {
                    this.$store.dispatch("diagrams/getModelForProcessDefinition").then(() => {
                        vm.$nextTick(() => {
                            vm.modelLoaded = true;
                        });
                    });
                }
            },
            immediate: true
        },
        showVariables: {
            handler(v) {
                const vm = this;

                if (v) {
                    this.$store.dispatch("diagrams/getVariables").then(() => {
                        vm.$nextTick(() => {
                            vm.variablesLoaded = true;
                        });
                    });
                }
            },
            immediate: true
        },
        showUsers: {
            handler(v) {
                const vm = this;

                if (v) {
                    if (this.getGroupsListApp.length) {
                        vm.rolesLoaded = true;
                    } else {
                        this.$store.dispatch("admin/actionGetGroupsApps");
                    }

                    this.$store.dispatch("admin/getUsersList").then(() => {
                        vm.$nextTick(() => {
                            vm.usersLoaded = true;
                        });
                    });
                }
            },
            immediate: true
        },
        getGroupsListApp: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    this.rolesLoaded = true;
                }
            },
            immediate: true
        },
        showDataText: {
            handler(v) {
                if (v) {
                    this.addNewFieldsData();
                }
            },
            immediate: true
        },
        showDynamicDataText: {
            handler(v) {
                if (v) {
                    this.addNewFieldsData();
                }
            },
            immediate: true
        }
    },
    created() {
        this.modelDataList = parseData(this.modelList);
        this.listDataList = parseDataList(this.listData);
        this.alreadySelectedUsers = [...this.localCheckedValues.user, ...this.localCheckedValues.role];
        this.initialUsers = [...this.localCheckedValues.user];
        this.initialGroups = [...this.localCheckedValues.role];
    },
    methods: {
        setAllUsersGroups(items, initialItems) {
            const dataItems = [...items];
            if (initialItems && initialItems.length) {
                initialItems.forEach(id => {
                    if (!items.includes(id)) {
                        dataItems.push(id);
                    }
                });
            }
            return dataItems;
        },
        fieldClicked(event, field, type) {
            const checkbox = event.currentTarget.querySelector('input[type="checkbox"]');

            if (checkbox) {
                checkbox.click();
            }
            this.$emit("fieldClicked", { field, type });
        },
        newFieldClicked(modelSelect) {
            const modelType = modelSelect.model.startsWith("m_") ? "model" : "variable";
            const field = {
                variable: modelSelect.formatted,
                name: modelSelect.model,
                type: modelSelect.type
            };

            this.$emit("fieldClicked", { field, type: modelType });
            if (modelType === "model") {
                this.$emit("tabChange", "dataModel");
            } else if (modelSelect.model.startsWith("s_")) {
                this.$emit("tabChange", "variables");
            }
        },
        fieldSelection(values) {
            const model = []; const
                variables = [];
            values.forEach(entry => {
                if (entry.formatted.startsWith("m_")) {
                    model.push(entry.key);
                }
                if (entry.formatted.startsWith("s_")) {
                    variables.push(entry.key);
                }
            });
            this.localCheckedValues.model = [...model];
            this.localCheckedValues.variable = [...variables];

            this.fieldChecked();
        },
        fieldChecked() {
            this.$emit("input", this.localCheckedValues);
        },
        addNewFields() {
            if (!this.hideFreeTextEmail) {
                if (this.localCheckedValues.freeText.length === 0) {
                    this.localCheckedValues.freeText.push({ email1: "" });
                } else {
                    for (let i = this.localCheckedValues.freeText.length - 1; i < this.localCheckedValues.freeText.length; i++) {
                        if (this.localCheckedValues.freeText[i].email1 !== "") {
                            this.localCheckedValues.freeText.push({ email1: "" });
                        }
                    }
                }
            } else if (!this.hideFreePhone) {
                if (this.localCheckedValues.freeText.length === 0) {
                    this.localCheckedValues.freeText.push({ phone1: "" });
                } else {
                    for (let i = this.localCheckedValues.freeText.length - 1; i < this.localCheckedValues.freeText.length; i++) {
                        if (this.localCheckedValues.freeText[i].phone1 !== "") {
                            this.localCheckedValues.freeText.push({ phone1: "" });
                        }
                    }
                }
            } else if (this.localCheckedValues.freeText.length === 0) {
                this.localCheckedValues.freeText.push({ email1: "", phone1: "" });
            } else {
                for (let i = this.localCheckedValues.freeText.length - 1; i < this.localCheckedValues.freeText.length; i++) {
                    if (this.localCheckedValues.freeText[i].email1 !== "" && this.localCheckedValues.freeText[i].phone1 !== "") {
                        this.localCheckedValues.freeText.push({ email1: "", phone1: "" });
                    }
                }
            }
        },

        addNewFieldsData() {
            if (this.localCheckedValues.dataTextList.length === 0) {
                this.localCheckedValues.dataTextList.push({ email2: "", phone2: "", list: "" });
            } else {
                for (let i = this.localCheckedValues.dataTextList.length - 1; i < this.localCheckedValues.dataTextList.length; i++) {
                    if (
                        this.localCheckedValues.dataTextList[i].email2 !== ""
                            && this.localCheckedValues.dataTextList[i].phone2 !== "") {
                        this.localCheckedValues.dataTextList.push({ email2: "", phone2: "", list: "" });
                    }
                }
            }
        },
        deleteField(index) {
            this.localCheckedValues.freeText.splice(index, 1);
            this.$emit("input", this.localCheckedValues);
        },
        deleteFieldData(index) {
            this.localCheckedValues.dataTextList.splice(index, 1);
            this.$emit("input", this.localCheckedValues);
        },
        search(value, done, selectedList) {
            if (this.showDynamicDataText) {
                for (let i = 0; i < this.listData.length; i++) {
                    if (selectedList !== "" && this.listData[i].name === selectedList) {
                        done(this.filterData(parseDataListFields(this.listData[i]), value));
                    }
                }
            } else {
                done(this.filterData(this.modelDataList, value));
            }
        },
        searchList(data, done) {
            done(this.filterData(this.listDataList, data));
        },
        filterData(data, value) {
            return data.filter(elem => elem.value === value);
        },
        onTabSelect(tab) {
            if (!["treeModel", "dataModel", "variables"].includes(tab)) {
                this.$emit("tabChange", tab);
            }
        },
        onTextValueChange(type) {
            const returnedValues = JSON.parse(JSON.stringify(this.localCheckedValues));

            returnedValues[type] = returnedValues[type].filter(el => (type === "freeText" && ((this.hideFreeTextPhone && el.email1)
            || (this.hideFreeTextEmail && el.phone1) || (el.email1 && el.phone1)))
                           || (type === "dataTextList" && el.email2 && el.phone2));

            this.$emit("input", returnedValues);
        }
    }
};
